import { noAuthRoute } from '@/router/guards/auth'
import TrackerInstallation from '@/views/forms/TrackerInstallation.vue'

export default {
  path: '/formulario-instalacao-rastreador',
  name: 'form-tracker-installation',
  component: TrackerInstallation,
  meta: {
    noAuth: true
  },

  beforeEnter (to, from, next) {
    const canEnter = noAuthRoute()

    if (canEnter) {
      return next(true)
    }

    next('/main')
  }
}
